/**
 * Country dial codes for phone fields, mirroring the `countries` gem
 * (`ISO3166::Country`) that the server uses, so an ISO code chosen here always
 * matches one the backend recognises. Regenerate from the gem if it changes.
 */
export interface CountryDialCode {
  /** ISO 3166-1 alpha-2 code, e.g. 'MY'. */
  iso: string
  name: string
  /** Dial code without the leading '+', e.g. '60'. */
  dialCode: string
}

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  { iso: 'AF', name: 'Afghanistan', dialCode: '93' },
  { iso: 'AL', name: 'Albania', dialCode: '355' },
  { iso: 'DZ', name: 'Algeria', dialCode: '213' },
  { iso: 'AS', name: 'American Samoa', dialCode: '1' },
  { iso: 'AD', name: 'Andorra', dialCode: '376' },
  { iso: 'AO', name: 'Angola', dialCode: '244' },
  { iso: 'AI', name: 'Anguilla', dialCode: '1' },
  { iso: 'AQ', name: 'Antarctica', dialCode: '672' },
  { iso: 'AG', name: 'Antigua and Barbuda', dialCode: '1' },
  { iso: 'AR', name: 'Argentina', dialCode: '54' },
  { iso: 'AM', name: 'Armenia', dialCode: '374' },
  { iso: 'AW', name: 'Aruba', dialCode: '297' },
  { iso: 'AU', name: 'Australia', dialCode: '61' },
  { iso: 'AT', name: 'Austria', dialCode: '43' },
  { iso: 'AZ', name: 'Azerbaijan', dialCode: '994' },
  { iso: 'BS', name: 'Bahamas', dialCode: '1' },
  { iso: 'BH', name: 'Bahrain', dialCode: '973' },
  { iso: 'BD', name: 'Bangladesh', dialCode: '880' },
  { iso: 'BB', name: 'Barbados', dialCode: '1' },
  { iso: 'BY', name: 'Belarus', dialCode: '375' },
  { iso: 'BE', name: 'Belgium', dialCode: '32' },
  { iso: 'BZ', name: 'Belize', dialCode: '501' },
  { iso: 'BJ', name: 'Benin', dialCode: '229' },
  { iso: 'BM', name: 'Bermuda', dialCode: '1' },
  { iso: 'BT', name: 'Bhutan', dialCode: '975' },
  { iso: 'BO', name: 'Bolivia', dialCode: '591' },
  { iso: 'BQ', name: 'Bonaire, Sint Eustatius and Saba', dialCode: '599' },
  { iso: 'BA', name: 'Bosnia and Herzegovina', dialCode: '387' },
  { iso: 'BW', name: 'Botswana', dialCode: '267' },
  { iso: 'BV', name: 'Bouvet Island', dialCode: '47' },
  { iso: 'BR', name: 'Brazil', dialCode: '55' },
  { iso: 'IO', name: 'British Indian Ocean Territory', dialCode: '246' },
  { iso: 'BN', name: 'Brunei Darussalam', dialCode: '673' },
  { iso: 'BG', name: 'Bulgaria', dialCode: '359' },
  { iso: 'BF', name: 'Burkina Faso', dialCode: '226' },
  { iso: 'BI', name: 'Burundi', dialCode: '257' },
  { iso: 'CV', name: 'Cabo Verde', dialCode: '238' },
  { iso: 'KH', name: 'Cambodia', dialCode: '855' },
  { iso: 'CM', name: 'Cameroon', dialCode: '237' },
  { iso: 'CA', name: 'Canada', dialCode: '1' },
  { iso: 'KY', name: 'Cayman Islands', dialCode: '1' },
  { iso: 'CF', name: 'Central African Republic', dialCode: '236' },
  { iso: 'TD', name: 'Chad', dialCode: '235' },
  { iso: 'CL', name: 'Chile', dialCode: '56' },
  { iso: 'CN', name: 'China', dialCode: '86' },
  { iso: 'CX', name: 'Christmas Island', dialCode: '61' },
  { iso: 'CC', name: 'Cocos (Keeling) Islands', dialCode: '61' },
  { iso: 'CO', name: 'Colombia', dialCode: '57' },
  { iso: 'KM', name: 'Comoros', dialCode: '269' },
  { iso: 'CG', name: 'Congo', dialCode: '242' },
  { iso: 'CD', name: 'Congo, The Democratic Republic of the', dialCode: '243' },
  { iso: 'CK', name: 'Cook Islands', dialCode: '682' },
  { iso: 'CR', name: 'Costa Rica', dialCode: '506' },
  { iso: 'HR', name: 'Croatia', dialCode: '385' },
  { iso: 'CU', name: 'Cuba', dialCode: '53' },
  { iso: 'CW', name: 'Curaçao', dialCode: '599' },
  { iso: 'CY', name: 'Cyprus', dialCode: '357' },
  { iso: 'CZ', name: 'Czechia', dialCode: '420' },
  { iso: 'CI', name: 'Côte d\'Ivoire', dialCode: '225' },
  { iso: 'DK', name: 'Denmark', dialCode: '45' },
  { iso: 'DJ', name: 'Djibouti', dialCode: '253' },
  { iso: 'DM', name: 'Dominica', dialCode: '1' },
  { iso: 'DO', name: 'Dominican Republic', dialCode: '1' },
  { iso: 'EC', name: 'Ecuador', dialCode: '593' },
  { iso: 'EG', name: 'Egypt', dialCode: '20' },
  { iso: 'SV', name: 'El Salvador', dialCode: '503' },
  { iso: 'GQ', name: 'Equatorial Guinea', dialCode: '240' },
  { iso: 'ER', name: 'Eritrea', dialCode: '291' },
  { iso: 'EE', name: 'Estonia', dialCode: '372' },
  { iso: 'SZ', name: 'Eswatini', dialCode: '268' },
  { iso: 'ET', name: 'Ethiopia', dialCode: '251' },
  { iso: 'FK', name: 'Falkland Islands (Malvinas)', dialCode: '500' },
  { iso: 'FO', name: 'Faroe Islands', dialCode: '298' },
  { iso: 'FJ', name: 'Fiji', dialCode: '679' },
  { iso: 'FI', name: 'Finland', dialCode: '358' },
  { iso: 'FR', name: 'France', dialCode: '33' },
  { iso: 'GF', name: 'French Guiana', dialCode: '594' },
  { iso: 'PF', name: 'French Polynesia', dialCode: '689' },
  { iso: 'TF', name: 'French Southern Territories', dialCode: '262' },
  { iso: 'GA', name: 'Gabon', dialCode: '241' },
  { iso: 'GM', name: 'Gambia', dialCode: '220' },
  { iso: 'GE', name: 'Georgia', dialCode: '995' },
  { iso: 'DE', name: 'Germany', dialCode: '49' },
  { iso: 'GH', name: 'Ghana', dialCode: '233' },
  { iso: 'GI', name: 'Gibraltar', dialCode: '350' },
  { iso: 'GR', name: 'Greece', dialCode: '30' },
  { iso: 'GL', name: 'Greenland', dialCode: '299' },
  { iso: 'GD', name: 'Grenada', dialCode: '1' },
  { iso: 'GP', name: 'Guadeloupe', dialCode: '590' },
  { iso: 'GU', name: 'Guam', dialCode: '1' },
  { iso: 'GT', name: 'Guatemala', dialCode: '502' },
  { iso: 'GG', name: 'Guernsey', dialCode: '44' },
  { iso: 'GN', name: 'Guinea', dialCode: '224' },
  { iso: 'GW', name: 'Guinea-Bissau', dialCode: '245' },
  { iso: 'GY', name: 'Guyana', dialCode: '592' },
  { iso: 'HT', name: 'Haiti', dialCode: '509' },
  { iso: 'HM', name: 'Heard Island and McDonald Islands', dialCode: '672' },
  { iso: 'VA', name: 'Holy See (Vatican City State)', dialCode: '39' },
  { iso: 'HN', name: 'Honduras', dialCode: '504' },
  { iso: 'HK', name: 'Hong Kong', dialCode: '852' },
  { iso: 'HU', name: 'Hungary', dialCode: '36' },
  { iso: 'IS', name: 'Iceland', dialCode: '354' },
  { iso: 'IN', name: 'India', dialCode: '91' },
  { iso: 'ID', name: 'Indonesia', dialCode: '62' },
  { iso: 'IR', name: 'Iran', dialCode: '98' },
  { iso: 'IQ', name: 'Iraq', dialCode: '964' },
  { iso: 'IE', name: 'Ireland', dialCode: '353' },
  { iso: 'IM', name: 'Isle of Man', dialCode: '44' },
  { iso: 'IL', name: 'Israel', dialCode: '972' },
  { iso: 'IT', name: 'Italy', dialCode: '39' },
  { iso: 'JM', name: 'Jamaica', dialCode: '1' },
  { iso: 'JP', name: 'Japan', dialCode: '81' },
  { iso: 'JE', name: 'Jersey', dialCode: '44' },
  { iso: 'JO', name: 'Jordan', dialCode: '962' },
  { iso: 'KZ', name: 'Kazakhstan', dialCode: '7' },
  { iso: 'KE', name: 'Kenya', dialCode: '254' },
  { iso: 'KI', name: 'Kiribati', dialCode: '686' },
  { iso: 'KW', name: 'Kuwait', dialCode: '965' },
  { iso: 'KG', name: 'Kyrgyzstan', dialCode: '996' },
  { iso: 'LA', name: 'Lao People\'s Democratic Republic', dialCode: '856' },
  { iso: 'LV', name: 'Latvia', dialCode: '371' },
  { iso: 'LB', name: 'Lebanon', dialCode: '961' },
  { iso: 'LS', name: 'Lesotho', dialCode: '266' },
  { iso: 'LR', name: 'Liberia', dialCode: '231' },
  { iso: 'LY', name: 'Libya', dialCode: '218' },
  { iso: 'LI', name: 'Liechtenstein', dialCode: '423' },
  { iso: 'LT', name: 'Lithuania', dialCode: '370' },
  { iso: 'LU', name: 'Luxembourg', dialCode: '352' },
  { iso: 'MO', name: 'Macao', dialCode: '853' },
  { iso: 'MG', name: 'Madagascar', dialCode: '261' },
  { iso: 'MW', name: 'Malawi', dialCode: '265' },
  { iso: 'MY', name: 'Malaysia', dialCode: '60' },
  { iso: 'MV', name: 'Maldives', dialCode: '960' },
  { iso: 'ML', name: 'Mali', dialCode: '223' },
  { iso: 'MT', name: 'Malta', dialCode: '356' },
  { iso: 'MH', name: 'Marshall Islands', dialCode: '692' },
  { iso: 'MQ', name: 'Martinique', dialCode: '596' },
  { iso: 'MR', name: 'Mauritania', dialCode: '222' },
  { iso: 'MU', name: 'Mauritius', dialCode: '230' },
  { iso: 'YT', name: 'Mayotte', dialCode: '262' },
  { iso: 'MX', name: 'Mexico', dialCode: '52' },
  { iso: 'FM', name: 'Micronesia, Federated States of', dialCode: '691' },
  { iso: 'MD', name: 'Moldova', dialCode: '373' },
  { iso: 'MC', name: 'Monaco', dialCode: '377' },
  { iso: 'MN', name: 'Mongolia', dialCode: '976' },
  { iso: 'ME', name: 'Montenegro', dialCode: '382' },
  { iso: 'MS', name: 'Montserrat', dialCode: '1' },
  { iso: 'MA', name: 'Morocco', dialCode: '212' },
  { iso: 'MZ', name: 'Mozambique', dialCode: '258' },
  { iso: 'MM', name: 'Myanmar', dialCode: '95' },
  { iso: 'NA', name: 'Namibia', dialCode: '264' },
  { iso: 'NR', name: 'Nauru', dialCode: '674' },
  { iso: 'NP', name: 'Nepal', dialCode: '977' },
  { iso: 'NL', name: 'Netherlands', dialCode: '31' },
  { iso: 'NC', name: 'New Caledonia', dialCode: '687' },
  { iso: 'NZ', name: 'New Zealand', dialCode: '64' },
  { iso: 'NI', name: 'Nicaragua', dialCode: '505' },
  { iso: 'NE', name: 'Niger', dialCode: '227' },
  { iso: 'NG', name: 'Nigeria', dialCode: '234' },
  { iso: 'NU', name: 'Niue', dialCode: '683' },
  { iso: 'NF', name: 'Norfolk Island', dialCode: '672' },
  { iso: 'KP', name: 'North Korea', dialCode: '850' },
  { iso: 'MK', name: 'North Macedonia', dialCode: '389' },
  { iso: 'MP', name: 'Northern Mariana Islands', dialCode: '1' },
  { iso: 'NO', name: 'Norway', dialCode: '47' },
  { iso: 'OM', name: 'Oman', dialCode: '968' },
  { iso: 'PK', name: 'Pakistan', dialCode: '92' },
  { iso: 'PW', name: 'Palau', dialCode: '680' },
  { iso: 'PS', name: 'Palestine, State of', dialCode: '970' },
  { iso: 'PA', name: 'Panama', dialCode: '507' },
  { iso: 'PG', name: 'Papua New Guinea', dialCode: '675' },
  { iso: 'PY', name: 'Paraguay', dialCode: '595' },
  { iso: 'PE', name: 'Peru', dialCode: '51' },
  { iso: 'PH', name: 'Philippines', dialCode: '63' },
  { iso: 'PN', name: 'Pitcairn', dialCode: '64' },
  { iso: 'PL', name: 'Poland', dialCode: '48' },
  { iso: 'PT', name: 'Portugal', dialCode: '351' },
  { iso: 'PR', name: 'Puerto Rico', dialCode: '1' },
  { iso: 'QA', name: 'Qatar', dialCode: '974' },
  { iso: 'RO', name: 'Romania', dialCode: '40' },
  { iso: 'RU', name: 'Russian Federation', dialCode: '7' },
  { iso: 'RW', name: 'Rwanda', dialCode: '250' },
  { iso: 'RE', name: 'Réunion', dialCode: '262' },
  { iso: 'BL', name: 'Saint Barthélemy', dialCode: '590' },
  { iso: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha', dialCode: '290' },
  { iso: 'KN', name: 'Saint Kitts and Nevis', dialCode: '1' },
  { iso: 'LC', name: 'Saint Lucia', dialCode: '1' },
  { iso: 'MF', name: 'Saint Martin (French part)', dialCode: '590' },
  { iso: 'PM', name: 'Saint Pierre and Miquelon', dialCode: '508' },
  { iso: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: '1' },
  { iso: 'WS', name: 'Samoa', dialCode: '685' },
  { iso: 'SM', name: 'San Marino', dialCode: '378' },
  { iso: 'ST', name: 'Sao Tome and Principe', dialCode: '239' },
  { iso: 'SA', name: 'Saudi Arabia', dialCode: '966' },
  { iso: 'SN', name: 'Senegal', dialCode: '221' },
  { iso: 'RS', name: 'Serbia', dialCode: '381' },
  { iso: 'SC', name: 'Seychelles', dialCode: '248' },
  { iso: 'SL', name: 'Sierra Leone', dialCode: '232' },
  { iso: 'SG', name: 'Singapore', dialCode: '65' },
  { iso: 'SX', name: 'Sint Maarten (Dutch part)', dialCode: '1' },
  { iso: 'SK', name: 'Slovakia', dialCode: '421' },
  { iso: 'SI', name: 'Slovenia', dialCode: '386' },
  { iso: 'SB', name: 'Solomon Islands', dialCode: '677' },
  { iso: 'SO', name: 'Somalia', dialCode: '252' },
  { iso: 'ZA', name: 'South Africa', dialCode: '27' },
  { iso: 'GS', name: 'South Georgia and the South Sandwich Islands', dialCode: '500' },
  { iso: 'KR', name: 'South Korea', dialCode: '82' },
  { iso: 'SS', name: 'South Sudan', dialCode: '211' },
  { iso: 'ES', name: 'Spain', dialCode: '34' },
  { iso: 'LK', name: 'Sri Lanka', dialCode: '94' },
  { iso: 'SD', name: 'Sudan', dialCode: '249' },
  { iso: 'SR', name: 'Suriname', dialCode: '597' },
  { iso: 'SJ', name: 'Svalbard and Jan Mayen', dialCode: '47' },
  { iso: 'SE', name: 'Sweden', dialCode: '46' },
  { iso: 'CH', name: 'Switzerland', dialCode: '41' },
  { iso: 'SY', name: 'Syrian Arab Republic', dialCode: '963' },
  { iso: 'TW', name: 'Taiwan', dialCode: '886' },
  { iso: 'TJ', name: 'Tajikistan', dialCode: '992' },
  { iso: 'TZ', name: 'Tanzania', dialCode: '255' },
  { iso: 'TH', name: 'Thailand', dialCode: '66' },
  { iso: 'TL', name: 'Timor-Leste', dialCode: '670' },
  { iso: 'TG', name: 'Togo', dialCode: '228' },
  { iso: 'TK', name: 'Tokelau', dialCode: '690' },
  { iso: 'TO', name: 'Tonga', dialCode: '676' },
  { iso: 'TT', name: 'Trinidad and Tobago', dialCode: '1' },
  { iso: 'TN', name: 'Tunisia', dialCode: '216' },
  { iso: 'TM', name: 'Turkmenistan', dialCode: '993' },
  { iso: 'TC', name: 'Turks and Caicos Islands', dialCode: '1' },
  { iso: 'TV', name: 'Tuvalu', dialCode: '688' },
  { iso: 'TR', name: 'Türkiye', dialCode: '90' },
  { iso: 'UG', name: 'Uganda', dialCode: '256' },
  { iso: 'UA', name: 'Ukraine', dialCode: '380' },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '971' },
  { iso: 'GB', name: 'United Kingdom', dialCode: '44' },
  { iso: 'US', name: 'United States', dialCode: '1' },
  { iso: 'UM', name: 'United States Minor Outlying Islands', dialCode: '1' },
  { iso: 'UY', name: 'Uruguay', dialCode: '598' },
  { iso: 'UZ', name: 'Uzbekistan', dialCode: '998' },
  { iso: 'VU', name: 'Vanuatu', dialCode: '678' },
  { iso: 'VE', name: 'Venezuela', dialCode: '58' },
  { iso: 'VN', name: 'Vietnam', dialCode: '84' },
  { iso: 'VG', name: 'Virgin Islands, British', dialCode: '1' },
  { iso: 'VI', name: 'Virgin Islands, U.S.', dialCode: '1' },
  { iso: 'WF', name: 'Wallis and Futuna', dialCode: '681' },
  { iso: 'EH', name: 'Western Sahara', dialCode: '212' },
  { iso: 'YE', name: 'Yemen', dialCode: '967' },
  { iso: 'ZM', name: 'Zambia', dialCode: '260' },
  { iso: 'ZW', name: 'Zimbabwe', dialCode: '263' },
  { iso: 'AX', name: 'Åland Islands', dialCode: '358' },
]

/** Falls back to Malaysia, where most events on the platform are held. */
export const DEFAULT_COUNTRY_ISO = 'MY'

const BY_ISO = new Map(COUNTRY_DIAL_CODES.map((country) => [country.iso, country]))

export const findCountryByIso = (iso: string | undefined | null): CountryDialCode | undefined =>
  iso ? BY_ISO.get(iso.toUpperCase()) : undefined

/**
 * Splits a stored number such as '+60123456789' into its country and the rest.
 * Dial codes overlap (e.g. '1' and '1242'), so the longest match wins.
 *
 * Countries also share dial codes outright — '+1' belongs to the US, Canada and
 * a dozen others — so `preferredIsos` (the country already selected, then any
 * the organiser pinned) decides between them instead of alphabetical order.
 */
export const splitPhoneNumber = (
  value: string | null | undefined,
  preferredIsos: Array<string | null | undefined> = []
): { iso?: string; nationalNumber: string } => {
  const raw = (value ?? '').trim()
  if (!raw.startsWith('+')) return { nationalNumber: raw }

  const digits = raw.slice(1)
  const dialCodeLength = COUNTRY_DIAL_CODES.reduce(
    (longest, country) =>
      digits.startsWith(country.dialCode) && country.dialCode.length > longest
        ? country.dialCode.length
        : longest,
    0
  )
  if (dialCodeLength === 0) return { nationalNumber: raw }

  const dialCode = digits.slice(0, dialCodeLength)
  const candidates = COUNTRY_DIAL_CODES.filter((country) => country.dialCode === dialCode)
  const preferred = preferredIsos
    .map((iso) => iso?.toUpperCase())
    .find((iso) => candidates.some((country) => country.iso === iso))

  const match = candidates.find((country) => country.iso === preferred) ?? candidates[0]

  return { iso: match.iso, nationalNumber: digits.slice(dialCodeLength) }
}

/** Renders a stored number for display, e.g. '+60 123456789'. */
export const formatPhoneNumberForDisplay = (value: string | null | undefined): string => {
  const raw = (value ?? '').trim()
  const { iso, nationalNumber } = splitPhoneNumber(raw)
  const country = findCountryByIso(iso)
  if (!country || !nationalNumber) return raw

  return `+${country.dialCode} ${nationalNumber}`
}

/** Joins a country and a typed number back into what gets stored. */
export const joinPhoneNumber = (iso: string, nationalNumber: string): string => {
  const country = findCountryByIso(iso)
  const rest = nationalNumber.replace(/[^0-9]/g, '')
  if (!country) return rest
  return rest ? `+${country.dialCode}${rest}` : ''
}
